/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListShiftManagerGroupsResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'ShiftManagerGroup',
        },
      },
    },
  }],
} as const;
